import React from "react";
import {
  ONBOARDING_GET_STARTED_ADD_LINK_TO_APP_PATH,
  ONBOARDING_GET_STARTED_INTEGRATE_SYNCED_DATA_PATH,
  ONBOARDING_GET_STARTED_SEND_API_REQUEST_PATH,
  ONBOARDING_GET_STARTED_SYNC_SANDBOX_DATA_PATH,
  ONBOARDING_ADVANCED_SYNCING_DATA_PATH,
  ONBOARDING_ADVANCED_MERGE_WRITES_PATH,
  ONBOARDING_ADVANCED_WEBHOOKS_PATH,
  ONBOARDING_ADVANCED_METADATA_PATH,
  ONBOARDING_ADVANCED_SUPPLEMENTAL_DATA_PATH,
  ONBOARDING_GET_STARTED_TOGGLE_SCOPES_PATH,
  ONBOARDING_AI_SKILLS_PATH,
} from "../../../router/RouterUtils";
import AIPluginsBanner from "./AIPluginsBanner";
import AddLinkToAppSection from "./components/add-link-to-app/AddLinkToAppSection";
import APIRequestSection from "./components/send-api-request/APIRequestSection";
import DashboardOnboardingWrapper from "./DashboardOnboardingWrapper";
import { DashboardOnboardingStatus } from "./types";
import IntegrateSyncedDataSection from "./components/integrate-synced-data/IntegrateSyncedDataSection";
import ScopesSection from "./components/set-toggle/ScopesSection";
import LinkedAccountSection from "./components/sync-sandbox/LinkedAccountSection";
import SyncingData from "./components/onboarding/SyncingData";
import MergeWrites from "./components/onboarding/MergeWrites";
import Webhooks from "./components/onboarding/Webhooks";
import Metadata from "./components/onboarding/Metadata";
import SupplementalData from "./components/onboarding/SupplementalData";

import { Redirect, Route, Switch } from "react-router-dom";
type DashboardOnboardingProps = {
  dashboardOnboardingStatus: DashboardOnboardingStatus | null;
};

const DashboardOnboarding = ({ dashboardOnboardingStatus }: DashboardOnboardingProps) => {
  return (
    <DashboardOnboardingWrapper dashboardOnboardingStatus={dashboardOnboardingStatus}>
      <Switch>
        <Route exact path={ONBOARDING_AI_SKILLS_PATH} children={<AIPluginsBanner standalone />} />
        <Route
          exact
          path={ONBOARDING_GET_STARTED_TOGGLE_SCOPES_PATH}
          children={<ScopesSection />}
        />
        <Route
          exact
          path={ONBOARDING_GET_STARTED_SYNC_SANDBOX_DATA_PATH}
          children={<LinkedAccountSection />}
        />
        <Route
          exact
          path={ONBOARDING_GET_STARTED_SEND_API_REQUEST_PATH}
          children={<APIRequestSection />}
        />
        <Route
          exact
          path={ONBOARDING_GET_STARTED_INTEGRATE_SYNCED_DATA_PATH}
          children={<IntegrateSyncedDataSection />}
        />
        <Route
          exact
          path={ONBOARDING_GET_STARTED_ADD_LINK_TO_APP_PATH}
          children={<AddLinkToAppSection />}
        />

        <Route exact path={ONBOARDING_ADVANCED_SYNCING_DATA_PATH} children={<SyncingData />} />
        <Route exact path={ONBOARDING_ADVANCED_MERGE_WRITES_PATH} children={<MergeWrites />} />
        <Route exact path={ONBOARDING_ADVANCED_WEBHOOKS_PATH} children={<Webhooks />} />
        <Route exact path={ONBOARDING_ADVANCED_METADATA_PATH} children={<Metadata />} />
        <Route
          exact
          path={ONBOARDING_ADVANCED_SUPPLEMENTAL_DATA_PATH}
          children={<SupplementalData />}
        />
        <Redirect to={ONBOARDING_AI_SKILLS_PATH} />
      </Switch>
    </DashboardOnboardingWrapper>
  );
};

export default DashboardOnboarding;
